// extracted by mini-css-extract-plugin
export default {"infinite-scroll-collapsable-table__loader":"infinite-scroll-collapsable-table_infinite-scroll-collapsable-table__loader__iLxWK"};